import paginationUtils from "./paginationUtils.js"
import paginationNewUtils from "./paginationNewUtils.js"
import generateDropDownListUtils from "./generateDropDownList"

export default {
  paginationUtils,
  paginationNewUtils,
  generateDropDownListUtils
}


//////////////////
// WEBPACK FOOTER
// ./utils/index.js
// module id = null
// module chunks = 